module.exports = __webpack_public_path__ + "static/media/2.4428ae14.JPG";